import { render, staticRenderFns } from "./updateAuditInfo.vue?vue&type=template&id=0b88d622&"
import script from "./updateAuditInfo.vue?vue&type=script&lang=tsx&"
export * from "./updateAuditInfo.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports